/**
 *
 * LabelBox
 *
 */

import { Box } from '@mui/material';
import React, { memo } from 'react';

const LabelBox = ({ children }) => (
  <Box width={'100%'} height={72}>
    {children}
  </Box>
);

export default memo(LabelBox);
